/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_ProjectInputs */

const en_new_project = /** @type {(inputs: New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Project`)
};

const fr_new_project = /** @type {(inputs: New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau projet`)
};

const de_new_project = /** @type {(inputs: New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Projekt`)
};

const it_new_project = /** @type {(inputs: New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo progetto`)
};

const ru_new_project = /** @type {(inputs: New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый проект`)
};

const es_new_project = /** @type {(inputs: New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo proyecto`)
};

const zh_cn2_new_project = /** @type {(inputs: New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新项目`)
};

const ja_new_project = /** @type {(inputs: New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいプロジェクト`)
};

const hi_new_project = /** @type {(inputs: New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नई परियोजना`)
};

const pt_pt2_new_project = /** @type {(inputs: New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo projeto`)
};

/**
* | output |
* | --- |
* | "New Project" |
*
* @param {New_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project = /** @type {((inputs?: New_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project(inputs)
	if (locale === "de") return de_new_project(inputs)
	if (locale === "it") return it_new_project(inputs)
	if (locale === "ru") return ru_new_project(inputs)
	if (locale === "es") return es_new_project(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project(inputs)
	if (locale === "ja") return ja_new_project(inputs)
	if (locale === "hi") return hi_new_project(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project(inputs)
	return en_new_project(inputs)
});